module.exports = __webpack_public_path__ + "img/pt.4d8e887.svg";